export default "__VITE_ASSET__3cea4bcd__"